import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dafttmptto0ceqqnhhig";

export default function TipForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐：命中则静默返回成功反馈，不真正提交
    const honeypot = ((fd.get("website_alt") as string) || "").trim();
    if (honeypot) {
      setStatus("success");
      return;
    }

    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === "website_alt") return;
      if (typeof value === "string" && value.trim() !== "") payload.append(key, value.trim());
    });

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isOk = res.ok && parsed?.code === "OK";

      if (isOk && !String(serverMsg).includes("spam")) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试。");
    }
  }

  return (
    <section id="tip" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* 左说明 */}
          <div className="lg:col-span-5">
            <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">SUBMIT A TIP</p>
            <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950 leading-tight">
              你掌握的线索，
              <br />
              或许就是下一个头条
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              呱呱爆料欢迎每一位读者投递独家线索。请尽量补充时间、地点、人物等可验证细节，编辑部会优先核实高价值线索，并在确认后第一时间跟进、脱敏发布。
            </p>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2.5">
                <span className="inline-flex w-7 h-7 items-center justify-center rounded-md bg-primary-100 text-primary-700"><i className="ri-shield-check-line" /></span>
                线索全程保密，可匿名投稿
              </li>
              <li className="flex items-center gap-2.5">
                <span className="inline-flex w-7 h-7 items-center justify-center rounded-md bg-accent-100 text-accent-800"><i className="ri-flag-2-line" /></span>
                优先核实高价值、可交叉验证内容
              </li>
              <li className="flex items-center gap-2.5">
                <span className="inline-flex w-7 h-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-900"><i className="ri-time-line" /></span>
                发布前统一脱敏，尊重个人隐私
              </li>
            </ul>
          </div>

          {/* 右表单 */}
          <div className="lg:col-span-7">
            <form
              id="tip-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="rounded-xl bg-background-50 border border-background-200/60 p-6 md:p-7"
            >
              <h3 className="text-lg text-foreground-950 mb-5">我要爆料</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="nickname" className="block text-sm text-foreground-700 mb-1.5">你的称呼</label>
                  <input
                    id="nickname"
                    name="nickname"
                    type="text"
                    placeholder="昵称或匿名"
                    className="w-full rounded-md border border-background-300/70 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm text-foreground-700 mb-1.5">联系方式</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="用于反馈核实结果"
                    className="w-full rounded-md border border-background-300/70 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label htmlFor="tip-type" className="block text-sm text-foreground-700 mb-1.5">线索类型</label>
                <select
                  id="tip-type"
                  name="tipType"
                  className="w-full rounded-md border border-background-300/70 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  defaultValue="圈内传闻"
                >
                  <option value="内部流出">内部流出</option>
                  <option value="首发曝光">首发曝光</option>
                  <option value="绝密文件">绝密文件</option>
                  <option value="圈内传闻">圈内传闻</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div className="mt-4">
                <label htmlFor="content" className="block text-sm text-foreground-700 mb-1.5">线索详情</label>
                <textarea
                  id="content"
                  name="content"
                  rows={5}
                  maxLength={500}
                  required
                  placeholder="请尽量描述时间、地点、人物等可验证细节（限 500 字）"
                  className="w-full rounded-md border border-background-300/70 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
                />
              </div>

              {/* 蜜罐 */}
              <div className="form-trap-field" aria-hidden="true">
                <label htmlFor="website_alt">网站</label>
                <input
                  type="text"
                  id="website_alt"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                />
              </div>

              {status === "error" && formError && (
                <p className="mt-4 rounded-md bg-primary-100 text-primary-800 px-3 py-2 text-sm">
                  <i className="ri-error-warning-line mr-1" />
                  {formError}
                </p>
              )}
              {status === "success" && (
                <p className="mt-4 rounded-md bg-secondary-100 text-secondary-900 px-3 py-2 text-sm">
                  <i className="ri-checkbox-circle-line mr-1" />
                  已收到你的线索，感谢支持！编辑部会尽快核实并跟进。
                </p>
              )}

              <button
                type="submit"
                disabled={status === "loading"}
                className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 hover:bg-primary-500 transition-colors whitespace-nowrap disabled:opacity-60"
              >
                {status === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin" />
                    提交中…
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line" />
                    提交线索
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}